// @ts-strict-ignore
import React, { useCallback } from 'react';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { Pressable } from 'react-native';
import { clickable } from '../../../styles';
import BodyText, { BodyTextAppearance, BodyTextWeight } from '../BodyText';
import Stack from '../Stack/Stack';
import ConditionalWrapper from '../ConditionalWrapper';

export interface UnderlineLinkProps {
  /** Called when the component is pressed */
  onPress?: () => void;
  /** The height of the underline */
  underlineHeight?: number;
  /** The vertical offset from the content of the underline */
  underlineVerticalOffset?: number;
  color?: BrandColor;
  children?: React.ReactNode;
  style?: object;
  textAppearance?: BodyTextAppearance;
  textWeight?: BodyTextWeight;
  testID?: string;
}

const UnderlineLink: React.FCWithChildren<UnderlineLinkProps> = ({
  onPress,
  underlineHeight = 1.5,
  underlineVerticalOffset = -1.5,
  color = BrandColor.BackInBlack,
  children,
  style,
  textAppearance = 'medium',
  textWeight = 'bold',
  testID,
}) => {
  const isTouchable = typeof onPress === 'function';
  const Wrapper = useCallback(child => (
    <Pressable
      onPress={onPress}
      accessibilityRole="link"
      testID={testID}
      style={clickable}
    >
      {child}
    </Pressable>
  ), [
    onPress,
    testID,
  ]);

  return (
    <ConditionalWrapper
      wrapper={Wrapper}
      condition={isTouchable}
    >
      <Stack
        style={style}
        testID={isTouchable ? null : testID}
      >
        <BodyText
          appearance={textAppearance}
          weight={textWeight}
          color={color}
        >
          {children}
        </BodyText>
        <Box
          flex={1}
          color={color}
          // @ts-expect-error This is a special padding case
          paddingTop={underlineHeight}
          bottom={underlineVerticalOffset}
        />
      </Stack>
    </ConditionalWrapper>
  );
};

export default UnderlineLink;
